var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeghabits1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16.0001C11.5523 16.0001 12 16.4478 12 17.0001V19.0001C12 19.5524 11.5523 20.0001 11 20.0001C10.4477 20.0001 10 19.5524 10 19.0001V17.0001C10 16.4478 10.4477 16.0001 11 16.0001Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16.0001C21.5523 16.0001 22 16.4478 22 17.0001V19.0001C22 19.5524 21.5523 20.0001 21 20.0001C20.4477 20.0001 20 19.5524 20 19.0001V17.0001C20 16.4478 20.4477 16.0001 21 16.0001Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001C16.5523 16.0001 17 16.4478 17 17.0001V19.0001C17 19.5524 16.5523 20.0001 16 20.0001C15.4477 20.0001 15 19.5524 15 19.0001V17.0001C15 16.4478 15.4477 16.0001 16 16.0001Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4016 12.0004L13.14 8.52409C13.4817 8.09024 13.3787 7.50195 12.9098 7.21011C12.4409 6.91828 11.7838 7.0334 11.442 7.46725L7.87117 12.0004H5.72974C4.81694 12.0004 4.11576 12.8088 4.24485 13.7125L5.53057 22.7125C5.63614 23.4515 6.26901 24.0004 7.01546 24.0004H24.9851C25.7315 24.0004 26.3644 23.4515 26.47 22.7125L27.7557 13.7125C27.8848 12.8088 27.1836 12.0004 26.2708 12.0004H24.4159L20.8497 7.47319C20.5079 7.03934 19.8508 6.92422 19.3819 7.21606C18.913 7.5079 18.81 8.09618 19.1517 8.53003L21.8854 12.0004H10.4016ZM6.30628 14.0004L7.44914 22.0004H24.5514L25.6942 14.0004H6.30628Z",
    fill: "currentcolor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeghabits1);
export default __webpack_public_path__ + "static/media/seghabits1.ddbd8db20645fbb1bec8f926f46ea87f.svg";
export { ForwardRef as ReactComponent };